import {
  ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiArg,
  ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const categoryApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query<
      ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiResponse,
      ClientMenuItemCategoriesControllerGetAllMenuCategoriesApiArg
    >({
      query: ({ locationId }) => ({
        url: 'menu-categories',
        params: {
          locationId,
        },
      }),
      providesTags: ['Categories'],
    }),
  }),
});

export const { useGetCategoriesQuery } = categoryApi;
